var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "contextMenu" } }, [
    _vm.viewMenu
      ? _c(
          "ul",
          {
            ref: "rightMenu",
            style: { top: _vm.top, left: _vm.left },
            attrs: { id: "right-click-menu", tabindex: "-1" }
          },
          [
            _c(
              "li",
              { attrs: { disabled: _vm.disableCut }, on: { click: _vm.cut } },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "cm-text" }, [_vm._v("Cut")]),
                _vm._v(" "),
                _c("div", { staticClass: "cm-key" }, [_vm._v("Cmd + x")])
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              { attrs: { disabled: _vm.disableCopy }, on: { click: _vm.copy } },
              [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "cm-text" }, [_vm._v("Copy")]),
                _vm._v(" "),
                _c("div", { staticClass: "cm-key" }, [_vm._v("Cmd + c")])
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "cm-group-end",
                attrs: { disabled: _vm.disablePaste },
                on: { click: _vm.paste }
              },
              [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "cm-text" }, [_vm._v("Paste here")]),
                _vm._v(" "),
                _c("div", { staticClass: "cm-key" }, [_vm._v("Cmd + v")])
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                attrs: { disabled: _vm.disableDelete },
                on: { click: _vm.destroy }
              },
              [
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "cm-text" }, [_vm._v("Delete")]),
                _vm._v(" "),
                _c("div", { staticClass: "cm-key" }, [_vm._v("Cmd + d")])
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cm-icon" }, [
      _c("i", { staticClass: "fa fa-cut" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cm-icon" }, [
      _c("i", { staticClass: "fa fa-copy" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cm-icon" }, [
      _c("i", { staticClass: "fa fa-paste" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cm-icon" }, [
      _c("i", { staticClass: "fa fa-trash" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-992b1c10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-992b1c10","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/contextMenu.vue
// module id = 1130
// module chunks = 2